/**
 * BrixiGo Landing Page — Brixigo Reference Style
 * ALL auth logic 100% preserved
 * Images placed per reference design
 */
// import {
//   FiPhoneCall,
//   FiMail,
//   FiClock,
//   FiMapPin,
//   FiChevronRight,
// } from "react-icons/fi";

// import {
//   FaCalculator,
//   FaMoneyBillWave,
//   FaCoins,
//   FaChartLine,
//   FaFileInvoiceDollar,
//   FaYoutube,
//   FaXTwitter,
//   FaBuildingColumns,
// } from "react-icons/fa6";

// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
// } from "react-icons/fa";


import React from "react";
import { useState, useEffect, useRef, useContext, useCallback } from "react";
import {
  Fingerprint, ShieldCheck, RefreshCw, Clock,
  Quote,
} from "lucide-react";
import BrixigoPageLoader from "../common/BrixigoPageLoader";
import MarketingNavbar from "../marketing/MarketingNavbar";
import Footer from "../marketing/Footer";
import "./brixigoLanding.css";

/* ── IMAGE IMPORTS ─────────────────────────────────────── */
// import brixigoLogo from "../assets/images/logo_brixigo3.png";

// Hero
import heroMainIllustration from "../assets/images/landing/hero-main.png";
import featurePayroll from "../assets/images/landing/feature-payroll.png";
import featureAttendance from "../assets/images/landing/feature-attendance.png";
import featureLeave from "../assets/images/landing/feature-leave.png";
import featureCompliance from "../assets/images/landing/feature-compliance.png";
import featureReports from "../assets/images/landing/feature-reports.png";
import featureESS from "../assets/images/landing/feature-ess.png";
import ctaTeamIllustration from "../assets/images/landing/cta-team-illustration.png";

// Feature cards

// Payroll Overview section left
import featureAutomationIllustration from "../assets/images/landing/feature-automation.png";
import biometricDeviceImg from "../assets/images/landing/biometric-device.webp";

// Mobile section — phone mockup with notification cards
import mobilePhoneHero from "../assets/images/landing/mobile-phone-hero.png";

import brixigoMascot from "../assets/images/brixigo-mascot.png";
import hrManagerPhoto from "../assets/images/landing/hr-manager.png";
import principalBrixigoPhoto from "../assets/images/landing/principal-brixigo.png";

import { AuthContext } from "../../Moduels/Context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import RegisterModal from "./RegisterModal";
import api from "../../services/api";
import { fetchLoginOptions, loginWithGoogleCredential } from "../../services/authService";
import SocialLoginPanel from "../auth/SocialLoginPanel";
import { mergeSocialProviders, resolveGoogleClientId } from "../../config/socialLoginConfig";
import { consumeSocialAuthError } from "../../utils/socialAuthSession";
import { getStoredAccessToken } from "../../utils/authSession";

import { Link } from "react-router-dom";

/* ── ICONS ─────────────────────────────────────────────── */
const Icon = {
  Check: ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  ArrowRight: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  User: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Mail: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Lock: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  Eye: ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
    </svg>
  ),
  EyeOff: ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ),
  Alert: ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Close: ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Shield: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  ChevronDown: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  Google: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.6h5.1c-.2 1.2-1.6 3.5-5.1 3.5-3.1 0-5.6-2.5-5.6-5.6S8.9 6.1 12 6.1c1.8 0 3 .8 3.7 1.4l2.5-2.4C16.9 3.7 14.6 2.7 12 2.7 6.9 2.7 2.7 6.9 2.7 12S6.9 21.3 12 21.3c6.9 0 8.6-4.8 8.6-7.2 0-.5 0-.9-.1-1.3H12z" />
      <path fill="#34A853" d="M3.9 7.5l3 2.2c.7-1.7 2.4-2.9 4.4-2.9 1.2 0 2.3.4 3.1 1.1l2.3-2.3C14.8 4.3 13.5 3.8 12 3.8 8.5 3.8 5.6 6.1 4.6 9.3l-.7-.8z" />
      <path fill="#4A90E2" d="M12 21.3c2.7 0 5-0.9 6.6-2.4l-3.1-2.5c-.9.6-2 .9-3.5.9-2.7 0-4.9-1.8-5.7-4.3l-3.1 2.4c1.5 3 4.7 4.9 8.8 4.9z" />
      <path fill="#FBBC05" d="M20.6 13.8c.1-.5.2-1 .2-1.5 0-.5-.1-1-.2-1.5H12v3.1h4.8c-.2 1.1-.9 2-1.9 2.6l3.1 2.4c1.8-1.7 2.6-4.2 2.6-7.1z" />
    </svg>
  ),
  BarChart: ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  Building: ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M9 22v-4h6v4" /><path d="M8 6h.01" /><path d="M16 6h.01" /><path d="M12 6h.01" /><path d="M12 10h.01" /><path d="M12 14h.01" /><path d="M16 10h.01" /><path d="M16 14h.01" /><path d="M8 10h.01" /><path d="M8 14h.01" />
    </svg>
  ),
  TrendingUp: ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  Headset: ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z" /><path d="M21 16v2a4 4 0 0 1-4 4h-5" />
    </svg>
  ),
};

const HERO_STRIP_ITEMS = [
  { icon: Icon.BarChart, label: "Data-Driven Payroll" },
  { icon: Icon.Building, label: "Industry Compliance" },
  { icon: Icon.TrendingUp, label: "Grow With Brixigo" },
  { icon: Icon.Headset, label: "Dedicated Support" },
];

const MASCOT_MESSAGES = [
  "BrixiGo automates PF, ESI & TDS — so you never miss a compliance deadline!",
  "Run payroll for 1,000+ employees in minutes, not days.",
  "Your team deserves accurate payslips — every single month.",
  "Statutory filings on autopilot. Focus on growing your business!",
  "From attendance to salary — one platform, zero headaches.",
];

const HR_SPEECH_MESSAGES = [
  "As an HR Manager, BrixiGo saves me 10+ hours every payroll cycle!",
  "One dashboard for payslips, leave approvals, and statutory compliance.",
  "No more spreadsheet errors — my team trusts every salary they receive.",
  "PF, ESI & TDS filings run automatically. I focus on people, not paperwork.",
  "New employee onboarding? BrixiGo sets them up in minutes, not days.",
  "Real-time attendance and payroll reports help me make faster HR decisions.",
];

const PRINCIPAL_SPEECH_MESSAGES = [
  "I use BrixiGo every month to pay salaries and manage our organisation — simple, secure, and always within reach.",
  "What once took days now takes minutes. Our entire staff is paid accurately, on time, every single month.",
  "From my desk to every payslip — BrixiGo helps me lead our institution with clarity and confidence.",
  "Automated payroll, instant payslips, and full compliance — everything our organisation needs in one trusted platform.",
  "Our team deserves transparency. With BrixiGo, every salary is clear and every report is ready when I need it.",
  "I chose BrixiGo because managing payroll should feel effortless — and for our organisation, it finally does.",
  "Paying salaries and staying compliant has never been this easy. BrixiGo gives me access whenever I need it.",
];

/* ── PARALLAX IMAGE CARD ───────────────────────────────── */
function ParallaxImageCard({ src, alt, frameClass = "", imgClass = "", intensity = 14, baseScale = 1 }) {
  const cardRef = useRef(null);
  const [transform, setTransform] = useState({ x: 0, y: 0, scale: baseScale });
  const [active, setActive] = useState(false);

  const handleMove = useCallback((e) => {
    const el = cardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setTransform({
      x: px * intensity,
      y: py * intensity,
      scale: baseScale * 1.04,
    });
    setActive(true);
  }, [intensity, baseScale]);

  const handleLeave = useCallback(() => {
    setTransform({ x: 0, y: 0, scale: baseScale });
    setActive(false);
  }, [baseScale]);

  return (
    <div
      ref={cardRef}
      className={`parallax-image-card${active ? " is-active" : ""}`}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <div className="parallax-image-glow" aria-hidden="true" />
      <div className={`parallax-image-frame ${frameClass}`.trim()}>
        <img
          src={src}
          alt={alt}
          className={`parallax-image-img ${imgClass}`.trim()}
          style={{
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0) scale(${transform.scale})`,
          }}
          draggable={false}
        />
      </div>
    </div>
  );
}

/* ── MARQUEE STRIP ─────────────────────────────────────── */
function HeroMarqueeStrip() {
  const items = [...HERO_STRIP_ITEMS, ...HERO_STRIP_ITEMS];
  return (
    <div className="bg-hero-strip bg-hero-strip-marquee" aria-label="Platform highlights">
      <div className="bg-hero-strip-track">
        {items.map(({ icon: Ico, label }, i) => (
          <div key={`${label}-${i}`} className="bg-hero-strip-item" aria-hidden={i >= HERO_STRIP_ITEMS.length}>
            <span className="bg-hero-strip-ico"><Ico size={16} /></span>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── CYCLING SPEECH FIGURE ─────────────────────────────── */
function CyclingSpeechFigure({ messages, imageSrc, imageAlt, imageClassName, wrapClassName = "" }) {
  const [msgIdx, setMsgIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setMsgIdx((i) => (i + 1) % messages.length);
        setVisible(true);
      }, 350);
    }, 4200);
    return () => clearInterval(cycle);
  }, [messages]);

  return (
    <div className={`mascot-speech-wrap${wrapClassName ? ` ${wrapClassName}` : ""}`}>
      <div className="mascot-figure">
        <div className={`mascot-speech-bubble${visible ? " is-visible" : ""}`} role="status" aria-live="polite">
          <span className="mascot-speech-text">{messages[msgIdx]}</span>
          <span className="mascot-speech-tail" aria-hidden="true" />
        </div>
        <img src={imageSrc} alt={imageAlt} className={imageClassName} draggable={false} />
      </div>
    </div>
  );
}

/* ── MASCOT SPEECH ─────────────────────────────────────── */
function MascotWithSpeech() {
  return (
    <CyclingSpeechFigure
      messages={MASCOT_MESSAGES}
      imageSrc={brixigoMascot}
      imageAlt="BrixiGo mascot"
      imageClassName="landing-mascot"
    />
  );
}


/* ── HERO ──────────────────────────────────────────────── */
function Hero({ onLoginClick, onBookDemoClick }) {
  const [heroScale, setHeroScale] = useState(1);

  useEffect(() => {
    const onResize = () => setHeroScale(1);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <section className="bg-hero" id="top">
      <div className="bg-hero-inner">
        <div className="bg-hero-left">
          <span className="bg-hero-eyebrow">Payroll &amp; HRMS Platform</span>
          <h1 className="bg-hero-h1">
            Less of the same,<br /><span className="hero-text-accent">more of the unique.</span>
          </h1>
          <p className="bg-hero-sub">
            Whether you are a <span className="hero-text-accent">startup or growing enterprise</span>, we help you
            stand out with <span className="hero-text-accent">automation and compliance</span> built for Indian payroll.
          </p>
          <div className="bg-hero-btns">
            <button className="bg-btn-green-lg" onClick={onLoginClick}>Start Free Trial <Icon.ArrowRight /></button>
            <button className="bg-btn-outline-lg" onClick={onBookDemoClick}>Book a Demo <Icon.ArrowRight /></button>
          </div>
        </div>
        <div className="bg-hero-right">
          <div className="hero-image-container">
            <ParallaxImageCard
              src={heroMainIllustration}
              alt="BrixiGo payroll dashboard with HR professional"
              frameClass="hero-illo-frame"
              imgClass="hero-main-img"
              intensity={18}
              baseScale={heroScale}
            />
          </div>
        </div>
      </div>
      <HeroMarqueeStrip />
    </section>
  );
}

/* ── FEATURES ──────────────────────────────────────────── */
function FeaturesSection() {
  const feats = [
    { img: featurePayroll, t: "Payroll Automation", d: "Automate salary processing, calculations, deductions and payouts.", link: "/features/payroll-automation" },
    { img: featureAttendance, t: "Attendance Tracking", d: "Track employee attendance in real-time with smart check-ins.", link: "/features/attendance-tracking" },
    { img: featureLeave, t: "Leave Management", d: "Manage leaves, holidays and approvals effortlessly.", link: "/features/leave-management" },
    { img: featureCompliance, t: "Compliance & TDS", d: "Stay compliant with tax rules and statutory regulations.", link: "/features/compliance-tds", cardClass: "feat-card-compliance" },
    { img: featureReports, t: "Reports & Analytics", d: "Get real-time insights with powerful reports and dashboards.", link: "/features/reports-analytics" },
    { img: featureESS, t: "Employee Self Service", d: "Empower employees to view payslips, apply leaves and more.", link: "/features/employee-self-service" },
  ];

  return (
    <section className="feat-sec" id="feat-sec">
      <div className="feat-sec-inner">
        <div className="saas-section-head saas-section-head-center">
          <span className="saas-eyebrow">Features</span>
          <h2 className="saas-title">Everything you need to run payroll</h2>
          <p className="saas-subtitle">Powerful tools built for modern HR teams and growing businesses</p>
        </div>
        <div className="feat-grid">
          {feats.map(({ img, t, d, link, cardClass }, i) => (
            <div className={`feat-card landing-card-reveal${cardClass ? ` ${cardClass}` : ""}`} key={t} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="feat-card-illus">
                <img src={img} alt={t} className="feat-card-img" />
              </div>
              <h3 className="feat-card-t">{t}</h3>
              <p className="feat-card-d">{d}</p>
              <Link to={link} className="feat-card-link">
                Learn More <Icon.ArrowRight />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── PRINCIPAL SPEECH VISUAL ───────────────────────────── */
function PrincipalSpeechVisual() {
  const [msgIdx, setMsgIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setMsgIdx((i) => (i + 1) % PRINCIPAL_SPEECH_MESSAGES.length);
        setVisible(true);
      }, 380);
    }, 4500);
    return () => clearInterval(cycle);
  }, []);

  return (
    <div className="principal-visual-card">
      <div className={`principal-speech-bubble${visible ? " is-visible" : ""}`} role="status" aria-live="polite">
        <span className="principal-speech-mark" aria-hidden="true">"</span>
        <p className="principal-speech-text">{PRINCIPAL_SPEECH_MESSAGES[msgIdx]}</p>
        <span className="principal-speech-tail" aria-hidden="true" />
      </div>
      <div className="principal-photo-frame">
        <ParallaxImageCard
          src={principalBrixigoPhoto}
          alt="Principal speaking about BrixiGo payroll at institution event"
          frameClass="principal-illo-frame"
          imgClass="principal-photo"
          intensity={10}
        />
        <span className="principal-role-badge">Principal</span>
      </div>
    </div>
  );
}

/* ── PRINCIPAL SPOTLIGHT SECTION ───────────────────────── */
function PrincipalSpotlightSection({ onLoginClick, onBookDemoClick }) {
  return (
    <section className="principal-sec" id="principal-spotlight">
      <div className="principal-sec-bg" aria-hidden="true" />
      <div className="principal-inner">
        <div className="principal-text landing-card-reveal">
          <span className="saas-eyebrow">Institution Leaders</span>
          <h2 className="product-h">Trusted by principals<br />&amp; administrators</h2>
          <p className="product-sub">
            Schools, colleges, and growing organisations rely on BrixiGo to pay salaries,
            manage staff records, and stay compliant — without the administrative burden.
          </p>
          <div className="product-checks">
            {[
              "Pay entire staff on time, every month",
              "Access payroll & reports from anywhere",
              "Secure, compliant salary processing",
              "Automated payslips for every employee",
              "Built for institutions that value trust",
            ].map((c) => (
              <div className="product-check" key={c}>
                <div className="product-check-ico"><Icon.Check size={12} /></div>{c}
              </div>
            ))}
          </div>
          <div className="principal-cta-row">
            <button type="button" className="product-btn" onClick={onLoginClick}>
              Start Free Trial <Icon.ArrowRight />
            </button>
            <button type="button" className="principal-btn-outline" onClick={onBookDemoClick}>
              Book a Demo <Icon.ArrowRight />
            </button>
          </div>
        </div>
        <div className="principal-visual landing-card-reveal" style={{ animationDelay: "0.12s" }}>
          <PrincipalSpeechVisual />
        </div>
      </div>
    </section>
  );
}

/* ── HR ADVISOR SECTION ────────────────────────────────── */
function HrAdvisorSection({ onLoginClick }) {
  return (
    <section className="hr-advisor-sec" id="hr-advisor">
      <div className="hr-advisor-inner">
        <div className="hr-advisor-visual landing-card-reveal">
          <CyclingSpeechFigure
            messages={HR_SPEECH_MESSAGES}
            imageSrc={hrManagerPhoto}
            imageAlt="HR Manager explaining BrixiGo payroll benefits"
            imageClassName="hr-advisor-photo"
            wrapClassName="hr-advisor-speech-wrap"
          />
        </div>
        <div className="hr-advisor-text landing-card-reveal" style={{ animationDelay: "0.1s" }}>
          <div className="product-eyebrow">For HR Professionals</div>
          <h2 className="product-h">Payroll that works<br />the way HR teams do</h2>
          <p className="product-sub">
            BrixiGo is built for HR managers who need accuracy, compliance, and speed —
            without juggling spreadsheets, emails, and multiple tools.
          </p>
          <div className="product-checks">
            {[
              "Process payroll in minutes, not days",
              "Approve leaves and attendance from one place",
              "Auto-generate payslips and Form 16",
              "Stay compliant with Indian labour laws",
              "Give employees self-service access",
            ].map((c) => (
              <div className="product-check" key={c}>
                <div className="product-check-ico"><Icon.Check size={12} /></div>{c}
              </div>
            ))}
          </div>
          <button type="button" className="product-btn" onClick={onLoginClick}>
            See It in Action <Icon.ArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
}

/* ── PAYROLL OVERVIEW SECTION ──────────────────────────── */
function PayrollOverviewSection({ onLoginClick }) {
  return (
    <section className="product-sec product-sec-white" id="payroll-overview">
      <div className="product-sec-inner payroll-overview-inner biometric-layout">
        <div className="product-text biometric-text landing-card-reveal">
          <div className="product-eyebrow">Biometric Attendance</div>
          <h2 className="product-h">Smart Biometric Attendance.<br />Accurate. Secure. Effortless.</h2>
          <p className="product-sub">
            Integrate biometric devices with BrixiGo to automate attendance tracking with real-time accuracy.
            Eliminate manual errors, prevent buddy punching, and ensure a transparent, reliable workforce — all in one platform.
          </p>
          <h3 className="payroll-benefits-title">Key Benefits</h3>
          <div className="product-checks payroll-benefits-checks">
            {[
              "Accurate & Real-Time Attendance Tracking",
              "Prevents Proxy & Buddy Punching",
              "Seamless Integration with BrixiGo",
              "Supports Multiple Biometric Devices",
              "Detailed Reports & Easy Monitoring",
            ].map((c) => (
              <div className="product-check" key={c}>
                <div className="product-check-ico"><Icon.Check size={12} /></div>{c}
              </div>
            ))}
          </div>
          <button type="button" className="product-btn" onClick={onLoginClick}>Learn More <Icon.ArrowRight /></button>
        </div>
        <div className="biometric-visual landing-card-reveal" style={{ animationDelay: "0.12s" }}>
          <div className="biometric-glow" />
          <div className="bio-callouts">
            <div className="bio-callout bio-callout--l1">
              <span className="bio-callout-icon"><Fingerprint size={22} /></span>
              <span className="bio-callout-label">Fingerprint<br/>Recognition</span>
            </div>
            <div className="bio-callout bio-callout--l2">
              <span className="bio-callout-icon"><ShieldCheck size={22} /></span>
              <span className="bio-callout-label">Secure<br/>& Reliable</span>
            </div>
            <div className="bio-callout bio-callout--l3">
              <span className="bio-callout-icon"><RefreshCw size={22} /></span>
              <span className="bio-callout-label">Real-time sync<br/>with BrixiGo</span>
            </div>
            <div className="bio-callout bio-callout--l4">
              <span className="bio-callout-icon"><Clock size={22} /></span>
              <span className="bio-callout-label">Real-time<br/>Attendance</span>
            </div>
            <span className="bio-line bio-line--fp-h" aria-hidden="true" />
            <span className="bio-line bio-line--fp-v" aria-hidden="true" />
            <span className="bio-line bio-line--sec-a" aria-hidden="true" />
            <span className="bio-line bio-line--sync-a" aria-hidden="true" />
            <span className="bio-line bio-line--att-h" aria-hidden="true" />
            <span className="bio-line bio-line--att-v" aria-hidden="true" />
          </div>
          <img
            src={biometricDeviceImg}
            alt="BrixiGo biometric attendance device"
            className="biometric-device-img"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
}

/* ── MOBILE SECTION ────────────────────────────────────── */
function MobileSection() {
  const features = [
    "Mark attendance from anywhere",
    "Apply and track leave requests",
    "View payslips and salary details",
    "Stay updated with notifications",
  ];

  return (
    <section className="mobile-sec" id="mobile-sec" aria-label="Mobile workforce management">
      <div className="mobile-sec-wrap landing-card-reveal">
        <div className="mobile-sec-inner">
          <div className="mobile-sec-text">
            <div className="product-eyebrow">Mobile Workforce Management</div>
            <h2 className="product-h">Manage Payroll<br />on the Go</h2>
            <p className="product-sub">
              Empower your employees and managers with the BrixiGo mobile app.
            </p>
            <div className="product-checks">
              {features.map((c) => (
                <div className="product-check" key={c}>
                  <div className="product-check-ico"><Icon.Check size={12} /></div>
                  {c}
                </div>
              ))}
            </div>
          </div>

          <div className="mobile-sec-visual">
            <img
              src={mobilePhoneHero}
              alt="BrixiGo mobile app showing leave balance, attendance, payslips and salary"
              className="mobile-phone-img"
              draggable={false}
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── TESTIMONIALS ──────────────────────────────────────── */
function Testimonials() {
  const testimonials = [
    { init: "RS", q: "BrixiGo has completely transformed our payroll process. It's accurate, fast and easy to use.", name: "Rohit Sharma", role: "HR Manager, TechSolutions" },
    { init: "PM", q: "The attendance tracking and leave management features are exceptional. Great support team!", name: "Priya Mehta", role: "Head of HR, GrowthWorks" },
    { init: "AV", q: "Finally, a payroll software that is simple, powerful and affordable.", name: "Ankit Verma", role: "Finance Manager, BuildCorp" },
  ];
  return (
    <section className="testi-sec" id="testi-sec">
      <div className="testi-inner">
        <div className="saas-section-head saas-section-head-center">
          <span className="saas-eyebrow">Testimonials</span>
          <h2 className="saas-title testi-h">Loved by HR teams and businesses</h2>
        </div>
        <div className="testi-grid">
          {testimonials.map(({ init, q, name, role }, i) => (
            <div className="tcard landing-card-reveal" key={name} style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="lp-icon-box tcard-quote" aria-hidden="true"><Quote size={20} strokeWidth={2} /></div>
              <p className="tcard-q">{q}</p>
              <div className="tcard-auth">
                <div className="tcard-av">{init}</div>
                <div><div className="tcard-name">{name}</div><div className="tcard-role">{role}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── PRICING ───────────────────────────────────────────── */
function Pricing({ onLoginClick, onBookDemoClick }) {
  const navigate = useNavigate();
  const plans = [
    {
      name: "Free", code: "free", desc: "For small teams to get started",
      currency: "₹", amount: "0", period: "/ month",
      popular: false,
      employees: "Up to 10 employees",
      features: ["Employee management", "Basic attendance", "Basic leave management", "Employee self-service (basic)", "Basic reports"],
      btnLabel: "Get Started Free", btnClass: "plan-btn", action: "signup",
    },
    {
      name: "Premium", code: "premium", desc: "Complete HRMS & Payroll",
      currency: "₹", amount: "50", period: "/ employee / month", mrp: "99", discount: "49% OFF",
      popular: true,
      minPrice: "₹1,999 / month for up to 40 employees",
      features: ["All Brixigo modules", "Payroll & statutory compliance", "Attendance & leave management", "Reports & analytics", "Role-based access (IAM)", "Employee self-service"],
      btnLabel: "Start Premium", btnClass: "plan-btn primary", action: "signup",
    },
    {
      name: "Customized", code: "enterprise", desc: "For growing & enterprise organizations",
      currency: "", amount: "Contact Sales", period: "", amountClass: "plan-amount-custom",
      popular: false,
      features: ["All Premium features", "Custom workflows", "Advanced reporting", "Integrations (API, third-party)", "Dedicated support & SLA", "Industry-specific configuration"],
      btnLabel: "Book a Demo", btnClass: "plan-btn", action: "demo",
    },
  ];
  const handlePlanAction = (action, code) => {
    if (action === "signup") navigate(`/registermodal?plan=${code || "free"}`);
    else if (action === "login") onLoginClick?.();
    else if (action === "demo") onBookDemoClick?.();
  };
  return (
    <section className="pricing-sec" id="pricing-sec">
      <div className="pricing-inner">
        <div className="saas-section-head saas-section-head-center">
          <span className="saas-eyebrow">Pricing</span>
          <h2 className="saas-title pricing-h">Pricing for Growing Businesses</h2>
          <p className="saas-subtitle pricing-sub">Start free. Upgrade when you need more. No credit card required.</p>
        </div>
        <div className="pricing-grid">
          {plans.map(({ name, code, desc, employees, currency, amount, period, popular, features, btnLabel, btnClass, action, amountClass, mrp, discount, minPrice }, i) => (
            <div className={`plan-card landing-card-reveal${popular ? " popular" : ""}`} key={name} style={{ animationDelay: `${i * 0.1}s` }}>
              {popular && <div className="plan-badge">Best Value</div>}
              <div className="plan-name">{name}</div>
              <div className="plan-desc">{desc}</div>
              <div className="plan-price">
                {mrp && <div className="plan-mrp">₹{mrp}</div>}
                {currency && <div className="plan-currency">{currency}</div>}
                <div className={`plan-amount${amountClass ? ` ${amountClass}` : ""}`}>{amount}</div>
                {period && <div className="plan-period">{period}</div>}
                {discount && <div className="plan-discount">{discount}</div>}
              </div>
              {employees && <div className="plan-employees">{employees}</div>}
              {minPrice && <div className="plan-min-price">{minPrice}</div>}
              <div className="plan-divider" />
              <div className="plan-features">
                {features.map((f) => (
                  <div className="plan-feature" key={f}>
                    <div className="plan-feature-ico"><Icon.Check size={12} /></div>{f}
                  </div>
                ))}
              </div>
              <button type="button" className={btnClass} onClick={() => handlePlanAction(action, code)}>{btnLabel}</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── FAQ ───────────────────────────────────────────────── */
const FAQS = [
  { q: "How quickly can we go live with BrixiGo?", a: "Most teams under 250 employees go live in 2-3 weeks. Our onboarding squad handles data migration, statutory setup and parallel runs end-to-end." },
  { q: "Is BrixiGo compliant with Indian statutory requirements?", a: "Yes. BrixiGo automatically handles PF, ESI, TDS, Professional Tax, and LWF across all 28 Indian states. Compliance rules update automatically when legislation changes." },
  { q: "Can my employees access their data on mobile?", a: "Absolutely. BrixiGo's mobile app lets employees access payslips, Form 16, leave balances and attendance - 24/7 on iOS and Android." },
  { q: "What pricing model do you use?", a: "We offer a Free plan for up to 10 employees, a Premium plan at ₹50/employee/month (₹1,999/month for up to 40 employees), and a Customized plan for enterprise needs. No credit card required to start." },
];

function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-sec bg-sec-s" id="faq-sec">
      <div className="bg-sec-inner">
        <div className="saas-section-head saas-section-head-center">
          <span className="saas-eyebrow">FAQ</span>
          <h2 className="saas-title">Questions? We have answers.</h2>
          <p className="saas-subtitle">Everything you need to know about getting started with BrixiGo</p>
        </div>
        <div className="bg-faq-box">
          {FAQS.map(({ q, a }, i) => (
            <div className={`bg-fi${open === i ? " open" : ""}`} key={i}>
              <button type="button" className="bg-fiq" aria-expanded={open === i} onClick={() => setOpen(open === i ? -1 : i)}>
                <span className="bg-fiq-text">{q}</span>
                <span className="bg-fich" aria-hidden="true"><Icon.ChevronDown /></span>
              </button>
              <div className="bg-fia"><div className="bg-fiat">{a}</div></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── CTA BANNER ────────────────────────────────────────── */
function CTABanner({ onLoginClick, onBookDemoClick }) {
  return (
    <section className="cta-sec" id="cta-sec">
      <div className="cta-banner">
        <div className="cta-banner-illo-wrap">
          <img
            src={ctaTeamIllustration}
            alt="Team using BrixiGo to manage payroll together"
            className="cta-banner-illo"
            draggable={false}
          />
        </div>
        <div className="cta-banner-main">
          <div className="cta-banner-copy">
            <h2 className="cta-banner-h">Ready to simplify your payroll?</h2>
            <p className="cta-banner-sub">Join 1,000+ businesses using BrixiGo to manage payroll effortlessly.</p>
          </div>
          <div className="cta-btns">
            <button className="cta-btn-white" onClick={onLoginClick}>Start Free Trial <Icon.ArrowRight /></button>
            <button className="cta-btn-outline" onClick={onBookDemoClick}>Book a Demo <Icon.ArrowRight /></button>
          </div>
        </div>
      </div>
    </section>
  );
}




/* ── FORGOT PASSWORD ───────────────────────────────────── */
function ForgotPasswordModal({ onClose, onBack, accountType = "admin" }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const isEmployee = accountType === "employee";
  const handleSend = async () => {
    if (!email.includes("@")) return;
    setLoading(true);
    try {
      const path = isEmployee ? "/employee-auth/forgot-password" : "/auth/forgot-password";
      const body = isEmployee ? { email } : { email, portal: "client" };
      await api.post(path, body);
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      alert(typeof d === "string" ? d : "Failed to send reset link");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="bg-modal-bg" onClick={onClose}>
      <div className="bg-forgot-modal" onClick={(e) => e.stopPropagation()}>
        <button className="bg-modal-close" onClick={onClose}><Icon.Close /></button>
        <div className="bg-forgot-modal-inner">
          {!sent ? (
            <>
              <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text)", marginBottom: 8 }}>Reset Password</div>
              <p style={{ fontSize: 13, color: "var(--text-lt)", marginBottom: 22, lineHeight: 1.6 }}>
                {isEmployee ? "Enter your work email to receive reset instructions." : "Enter your admin account email."}
              </p>
              <label className="bg-flbl" style={{ margin: "0 0 6px" }}>Email Address</label>
              <div className="bg-fwrap" style={{ margin: "0 0 16px" }}>
                <span className="bg-fico"><Icon.Mail /></span>
                <input className="bg-finput" type="email" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
              </div>
              <button className="bg-sbtn bg-sbtn-admin" onClick={handleSend} disabled={loading || !email.includes("@")} style={{ opacity: loading || !email.includes("@") ? 0.7 : 1 }}>
                {loading ? <><span className="bg-spinner" /> Sending…</> : "Send Reset Link"}
              </button>
              <button type="button" className="bg-forgot-back-btn" onClick={onBack}>← Back to Sign In</button>
            </>
          ) : (
            <div className="bg-forgot-success">
              <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#DCFCE7", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "#16A34A" }}><Icon.Check size={24} /></div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text)", marginBottom: 10 }}>Check your inbox</div>
              <p style={{ fontSize: 14, color: "var(--text-lt)", marginBottom: 24 }}>Reset link sent to <strong>{email}</strong>. Expires in 30 min.</p>
              <button type="button" className="bg-sbtn bg-sbtn-admin" onClick={onBack}>Back to Sign In</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── LOGIN MODAL (all logic preserved) ─────────────────── */
function resolveAuthSubmitError(err, { isAdmin }) {
  const detail = err?.response?.data?.detail;
  const code = detail && typeof detail === "object" ? detail.code : null;
  const raw =
    (typeof detail === "string" ? detail : detail?.message || null) ||
    err?.response?.data?.message ||
    err?.message ||
    "";
  const lo = String(raw || "").toLowerCase();
  const status = err?.response?.status;

  if (!err?.response && (lo.includes("network") || lo.includes("timeout") || err?.code === "ERR_NETWORK")) {
    return {
      banner: "Cannot reach the server. Start the backend API (port 9000) and try again.",
    };
  }

  if (code === "ACCOUNT_NOT_FOUND") {
    return { type: "ACCOUNT_NOT_FOUND" };
  }

  if (code === "INVALID_PASSWORD") {
    return { type: "INVALID_PASSWORD" };
  }

  if (lo.includes("not found") || lo.includes("no user") || lo.includes("no account")) {
    return { type: "ACCOUNT_NOT_FOUND" };
  }

  if (
    lo.includes("password") ||
    lo.includes("incorrect") ||
    lo.includes("invalid username") ||
    lo.includes("invalid email") ||
    lo.includes("invalid credentials")
  ) {
    return { type: "INVALID_PASSWORD" };
  }

  if (lo.includes("inactive")) {
    return { banner: "This account is inactive. Contact your administrator." };
  }

  if (status === 403 && raw) {
    return { banner: raw };
  }

  if (raw) {
    return { banner: raw };
  }

  return { banner: "Sign in failed. Check credentials and try again." };
}

function LoginModal({ onClose }) {
  const [view, setView] = useState("login");
  const [role, setRole] = useState("admin");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldErr, setFieldErr] = useState({ id: "", pw: "" });
  const [authErr, setAuthErr] = useState("");
  const [authErrorType, setAuthErrorType] = useState(null);
  const [orgPickOpen, setOrgPickOpen] = useState(false);
  const [orgPickMessage, setOrgPickMessage] = useState("");
  const [orgPickOptions, setOrgPickOptions] = useState([]);
  const [orgPickOrganisationId, setOrgPickOrganisationId] = useState("");
  const [loginOptions, setLoginOptions] = useState(null);
  const [loginOptionsLoading, setLoginOptionsLoading] = useState(true);
  const navigate = useNavigate();
  const { login, loginWithToken } = useContext(AuthContext);
  const idRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setLoginOptionsLoading(true);
    fetchLoginOptions()
      .then((data) => {
        if (!cancelled) setLoginOptions(data);
      })
      .catch(() => {
        if (!cancelled) setLoginOptions(null);
      })
      .finally(() => {
        if (!cancelled) setLoginOptionsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const socialError = consumeSocialAuthError();
    if (socialError) setAuthErr(socialError);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => idRef.current?.focus(), 60);
    return () => clearTimeout(t);
  }, [role]);

  const switchRole = (r) => {
    if (loading) return;
    setRole(r);
    setUsername("");
    setEmail("");
    setPassword("");
    setShowPw(false);
    setFieldErr({ id: "", pw: "" });
    setAuthErr("");
    setAuthErrorType(null);
  };

  const isAdmin = role === "admin";

  const ADMIN_USERNAME_RE = /^[A-Za-z0-9_]+$/;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = () => {
    const e = { id: "", pw: "" };
    let ok = true;
    if (isAdmin) {
      const u = username.trim();
      if (!u) { e.id = "Username or email is required."; ok = false; }
      else if (u.includes("@")) {
        if (!EMAIL_RE.test(u)) { e.id = "Enter a valid email address."; ok = false; }
      } else if (u.length < 3) { e.id = "Min 3 characters."; ok = false; }
      else if (!ADMIN_USERNAME_RE.test(u)) { e.id = "Letters, numbers and underscores only — or use your email."; ok = false; }
    } else {
      const em = email.trim();
      if (!em) { e.id = "Email is required."; ok = false; }
      else if (!em.includes("@")) { e.id = "Enter your work email (e.g. you@company.com)."; ok = false; }
      else if (!EMAIL_RE.test(em)) { e.id = "Enter a valid email address."; ok = false; }
    }
    if (!password) { e.pw = "Password is required."; ok = false; }
    else if (password.length < 6) { e.pw = "Min 6 characters."; ok = false; }
    setFieldErr(e);
    return ok;
  };

  const submit = async () => {
    if (loading) return;
    setAuthErr("");
    setAuthErrorType(null);
    if (!validate()) return;
    setLoading(true);
    try {
      await login({ mode: isAdmin ? "admin" : "employee", identifier: isAdmin ? username.trim() : email.trim(), password });
      navigate("/dashboard");
      onClose();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const detailCode = detail && typeof detail === "object" ? detail.code : null;
      if (!isAdmin && detailCode === "multiple_organisations" && Array.isArray(detail?.organisations)) {
        setOrgPickOptions(detail.organisations);
        setOrgPickMessage(detail.message || "Select organisation to sign in.");
        setOrgPickOrganisationId(detail.organisations[0]?.organisation_id || "");
        setOrgPickOpen(true);
        setFieldErr({ id: "", pw: "" });
        return;
      }
      const mapped = resolveAuthSubmitError(err, { isAdmin });
      if (mapped.type === "ACCOUNT_NOT_FOUND") {
        setAuthErrorType("ACCOUNT_NOT_FOUND");
      } else if (mapped.type === "INVALID_PASSWORD") {
        setAuthErrorType("INVALID_PASSWORD");
      } else {
        setAuthErr(mapped.banner || "Sign in failed. Check credentials and try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const submitWithOrganisation = async (organisation_id) => {
    if (!organisation_id) return;
    setOrgPickOpen(false);
    setAuthErr("");
    setAuthErrorType(null);
    setFieldErr({ id: "", pw: "" });
    setLoading(true);
    try {
      await login({ mode: "employee", identifier: email.trim(), password, organisation_id });
      navigate("/dashboard");
      onClose();
    } catch (err) {
      setAuthErr(err?.response?.data?.detail?.message || err?.response?.data?.detail || "Sign in failed.");
    } finally {
      setLoading(false);
    }
  };

  const googleClientId = resolveGoogleClientId(loginOptions);
  const socialProviders = mergeSocialProviders(loginOptions?.social_providers, { googleClientId });

  const handleProviderNotice = (message) => {
    setAuthErr(message);
  };

  const handleGoogleCredential = async (credential) => {
    if (loading) return;
    setAuthErr("");
    setLoading(true);
    try {
      const data = await loginWithGoogleCredential(credential);
      await loginWithToken(data.access_token);
      navigate("/dashboard");
      onClose();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setAuthErr(typeof detail === "string" ? detail : "Google sign-in failed. Try email login.");
    } finally {
      setLoading(false);
    }
  };

  if (view === "register") {
    return (
      <RegisterModal
        fullPage
        onClose={onClose}
        onSwitchToLogin={() => setView("login")}
      />
    );
  }
  if (view === "forgot") return <ForgotPasswordModal onClose={onClose} onBack={() => setView("login")} accountType={isAdmin ? "admin" : "employee"} />;

  return (
    <div className="bg-modal-bg" onClick={onClose}>
      <div className="bg-modal bg-modal-social" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="bg-modal-head">
          <h2 className="bg-modal-title">Log in to BrixiGo</h2>
          <button className="bg-modal-close" onClick={onClose} aria-label="Close"><Icon.Close /></button>
        </div>

        <div className="bg-modal-body">
          <section className="bg-login-email">
            <div className="bg-role-tabs">
              <button className={`bg-rtab${isAdmin ? " active" : ""}`} onClick={() => switchRole("admin")} disabled={loading}><Icon.Shield /> Admin · HR</button>
              <button className={`bg-rtab${!isAdmin ? " active" : ""}`} onClick={() => switchRole("employee")} disabled={loading}><Icon.User size={14} /> Employee</button>
            </div>

            {!isAdmin && <div className="bg-notice">Use the <strong>email address</strong> assigned by your HR team.</div>}
            {authErr && <div className="bg-auth-err" role="alert"><Icon.Alert /> {authErr}</div>}
            {authErrorType === "ACCOUNT_NOT_FOUND" && (
              <div className="bg-acct-hint" role="alert"><Icon.Alert size={13} /> No account found. Create an account to get started.</div>
            )}
            {orgPickOpen && (
              <div className="bg-org-picker">
                <div className="bg-org-picker-msg">{orgPickMessage}</div>
                <select value={orgPickOrganisationId} onChange={(e) => setOrgPickOrganisationId(e.target.value)} disabled={loading}>
                  {(orgPickOptions || []).map((o) => (
                    <option key={o.organisation_id} value={o.organisation_id}>{o.name}</option>
                  ))}
                </select>
                <div className="bg-org-picker-btns">
                  <button type="button" className="bg-org-continue" disabled={loading || !orgPickOrganisationId} onClick={() => submitWithOrganisation(orgPickOrganisationId)}>Continue</button>
                  <button type="button" className="bg-org-cancel" disabled={loading} onClick={() => setOrgPickOpen(false)}>Cancel</button>
                </div>
              </div>
            )}

            <label className="bg-flbl">{isAdmin ? "Username or Email" : "Work Email"}</label>
            <div className="bg-fwrap">
              <span className="bg-fico">{isAdmin ? <Icon.User /> : <Icon.Mail />}</span>
              <input
                ref={idRef}
                className={`bg-finput${fieldErr.id ? " err" : ""}`}
                type={isAdmin ? "text" : "email"}
                placeholder={isAdmin ? "username or you@company.com" : "you@company.com"}
                value={isAdmin ? username : email}
                onChange={(e) => {
                  if (isAdmin) setUsername(e.target.value);
                  else setEmail(e.target.value);
                  setFieldErr((p) => ({ ...p, id: "" }));
                  setAuthErr("");
                  setAuthErrorType(null);
                }}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                autoComplete={isAdmin ? "username" : "email"}
              />
            </div>
            {fieldErr.id && <div className="bg-ferr"><Icon.Alert /> {fieldErr.id}</div>}

            <div className="bg-pw-row">
              <label className="bg-flbl">Password</label>
              <button className="bg-forgot" type="button" onClick={() => setView("forgot")}>Forgot password?</button>
            </div>
            <div className="bg-fwrap">
              <span className="bg-fico"><Icon.Lock /></span>
              <input
                className={`bg-finput${fieldErr.pw || authErrorType === "INVALID_PASSWORD" ? " err" : ""}`}
                style={{ paddingRight: 42 }}
                type={showPw ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setFieldErr((p) => ({ ...p, pw: "" }));
                  setAuthErr("");
                  setAuthErrorType(null);
                }}
                onKeyDown={(e) => e.key === "Enter" && submit()}
              />
              <button type="button" className="bg-pw-toggle" onClick={() => setShowPw((v) => !v)}>{showPw ? <Icon.EyeOff /> : <Icon.Eye />}</button>
            </div>
            {fieldErr.pw && <div className="bg-ferr"><Icon.Alert /> {fieldErr.pw}</div>}
            {authErrorType === "INVALID_PASSWORD" && <div className="bg-ferr"><Icon.Alert /> Incorrect password. Try again.</div>}

            <div className="bg-rem-row" onClick={() => setRemember((v) => !v)}>
              <div className={`bg-rchk${remember ? " on" : ""}`}>{remember && <Icon.Check size={10} />}</div>
              <span className="bg-rlbl">Keep me signed in</span>
            </div>

            <button type="button" className={`bg-sbtn ${isAdmin ? "bg-sbtn-admin" : "bg-sbtn-emp"}`} onClick={submit} disabled={loading}>
              {loading ? <><span className="bg-spinner" /> Signing in…</> : <>Sign In <Icon.ArrowRight /></>}
            </button>

            {isAdmin && (
              <>
                <div className="bg-divider">New to BrixiGo?</div>
                <button type="button" className="bg-reg-btn" onClick={() => setView("register")} disabled={loading}>Create Admin Account</button>
              </>
            )}
          </section>

          <div className="bg-divider social-divider">Or continue with</div>

          <section className="bg-login-social">
            <SocialLoginPanel
              providers={socialProviders}
              googleClientId={googleClientId}
              loading={loading || loginOptionsLoading}
              onGoogleCredential={handleGoogleCredential}
              onProviderNotice={handleProviderNotice}
            />
          </section>

          <div className="bg-sec-note"><Icon.Lock size={12} /> 256-bit TLS encrypted · Your data is safe</div>
        </div>
      </div>
    </div>
  );
}

/* ── ROOT EXPORT ───────────────────────────────────────── */
export default function BrixiGoLandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading: authLoading } = useContext(AuthContext);
  const isLoginRoute = location.pathname === "/login";
  const [showLogin, setShowLogin] = useState(isLoginRoute);

  useEffect(() => {
    if (isLoginRoute) setShowLogin(true);
  }, [isLoginRoute]);

  useEffect(() => {
    if (authLoading) return;
    const token = getStoredAccessToken();
    if (user && token) {
      navigate("/dashboard", { replace: true });
    }
  }, [authLoading, user, navigate]);

  useEffect(() => {
    document.body.style.overflow = showLogin ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showLogin]);

  const openLogin = useCallback(() => setShowLogin(true), []);
  const closeLogin = useCallback(() => {
    setShowLogin(false);
    if (location.pathname === "/login") {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);
  const openBookDemo = useCallback(() => navigate("/book-demo"), [navigate]);

  useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return undefined;
    const timer = window.setTimeout(() => {
      window.scrollTo({ top: el.offsetTop - 76, behavior: "smooth" });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [location.hash, location.pathname]);

  if (authLoading) {
    return <BrixigoPageLoader overlay message="Loading…" />;
  }

  return (
    <div className="brixigo-landing" style={{ minHeight: "100vh" }}>
      <MarketingNavbar onLoginClick={openLogin} onBookDemoClick={openBookDemo} />
      <main>
        <Hero onLoginClick={openLogin} onBookDemoClick={openBookDemo} />
        <FeaturesSection />
        <HrAdvisorSection onLoginClick={openLogin} />
        <PayrollOverviewSection onLoginClick={openLogin} />
        <PrincipalSpotlightSection onLoginClick={openLogin} onBookDemoClick={openBookDemo} />
        <MobileSection />
        <Testimonials />
        <Pricing onLoginClick={openLogin} onBookDemoClick={openBookDemo} />
        <FAQ />
        <CTABanner onLoginClick={openLogin} onBookDemoClick={openBookDemo} />
      </main>
      <Footer />
      {showLogin && <LoginModal onClose={closeLogin} />}
    </div>
  );
}
